import { Switch, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { FormattedDateWidthDateTime } from "@src/components";
import { type FC, type PropsWithChildren } from "react";
import styled from "styled-components";

const StyledTypography = styled(Typography)`
    word-break: break-all;
`;
export interface DisplayComponentProps {
    type?: "date" | "checkbox" | "switch";
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any;
    checkboxLabel?: string;
}

const DisplayComponent: FC<PropsWithChildren<DisplayComponentProps>> = ({ type, value, checkboxLabel }) => {
    if (type === "date") {
        return (
            value && (
                <StyledTypography>
                    <FormattedDateWidthDateTime value={value} />
                </StyledTypography>
            )
        );
    } else if (type === "checkbox") {
        return (
            value && (
                <>
                    <Checkbox checked={value} disabled />
                    <StyledTypography>{checkboxLabel}</StyledTypography>
                </>
            )
        );
    } else if (type === "switch") {
        return (
            <>
                <Switch checked={!!value} />
                <StyledTypography>{checkboxLabel}</StyledTypography>
            </>
        );
    }

    return <StyledTypography>{value}</StyledTypography>;
};

export default DisplayComponent;
